/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-15 14:49:38
 * @LastEditors: K
 * @LastEditTime: 2022-09-09 16:28:22
 */
import { Button, Space, TableColumnType, Image } from "antd";
import React from "react";
import { StateSwitch } from "../../compnents/widgets/StateSwitch";
import { BillingCategoryName } from "../../models/billingCategory";
import { getMaterialsName, Materials } from "../../models/commodity";
import { Dimen } from "../../models/dimen";
import { getOtcCategoryName } from "../../models/Otccategory";


export const Columns = (
  onClick: (action: 'edit' | 'delete', id: any, t: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {

  const getPlatFormType = (type: number) => {
    switch (type) {
      case 0:
        return '机构端登录页'

      default:
        return '机构端登录页'
    }
  }
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "图片",
      align: "center",
      dataIndex: "name",
      render: function Element(_, t) {
        return (
          <Image src={t.imgUrlPath} style={{ width: 80, height: 80 }} />

        );
      },
    },
    {
      title: "展示位置",
      align: "center",
      dataIndex: "seq",
    },
    {
      title: "状态",
      align: "center",
      dataIndex: "status",
      render: (_, t) => t.status == 0 ? '正常' : '禁用',
    },
    // {
    //   title: "平台",
    //   align: "center",
    //   dataIndex: "platformType",
    //   render: (_, t) => getPlatFormType(t.platformType),
    // },
    {
      title: "操作",
      align: "center",
      fixed: "right",
      width: "6rem",
      render: function Element(_, t) {
        return (
          <Space>
            <a href="javascript:;" onClick={() => {
              onClick('edit', t.id, t)
            }}>编辑</a>
            <a href="javascript:;" onClick={() => {
              onClick('delete', t.id, t)
            }}>删除</a>
          </Space>

        );
      },
    },
  ];
};
